// Defensive guard: some schools have generic/shared Joomla logins that are
// not real staff (e.g. "SCHOOL ADMINISTRATOR", "SUPER USER"). These should
// never be selectable as a ticket assignee, even if one of them ever shows
// up in a school's staff data.

const GENERIC_LOGIN_NAMES = ["SCHOOL ADMINISTRATOR", "SUPER USER"];

function fullName(staff) {
  return [staff.first_name, staff.middle_name, staff.last_name]
    .filter(Boolean)
    .join(" ")
    .trim()
    .toUpperCase();
}

export function isGenericStaffLogin(staff) {
  return GENERIC_LOGIN_NAMES.indexOf(fullName(staff)) !== -1;
}

export function filterGenericStaff(staffList) {
  if (!Array.isArray(staffList)) return staffList;
  return staffList.filter(function (s) { return !isGenericStaffLogin(s); });
}
